// Formats a date string as "D Month YYYY" (e.g. "9 July 2026")
// using en-GB locale with long month names.
// Returns empty string for null/undefined/empty input.
export function formatLongDate(dateString) {
    if (!dateString) return "";
    return new Date(dateString).toLocaleDateString("en-GB", {
        year: "numeric",
        month: "long",
        day: "numeric",
    });
}
